import { Avatar, Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import CommonModel from "../../../components/dialog/Common";
import { getCompanyid, getFormatedDate, getFormatedNumber } from "../../../utils/common";
import { getAllBrandForDropDown } from "../../brands/action";
import { cancelRecurringSubscription, getActivePlanDetails } from "../action";
import { resetSubscription, updateSubscription } from "../subscriptionSlice";
import myPlanIcon from '../../../assets/images/icons/crown.svg'
import questionCircle from '../../../assets/images/icons/questionCircle.svg'
import diamond from '../../../assets/images/icons/diamond.svg'
import recipt from '../../../assets/images/icons/Receipt.svg'
import creditCard from '../../../assets/images/icons/Credit.svg'
import user from '../../../assets/images/icons/user.svg'
import userCheck from '../../../assets/images/icons/usercheck.svg'
import rocket from '../../../assets/images/icons/Rocket.svg'
import paidIcon from '../../../assets/images/icons/paid.svg'
import questionGrey from '../../../assets/images/icons/questiongray.svg'
import barter from '../../../assets/images/icons/barter.svg'
import performance from '../../../assets/images/icons/performance.svg'
import affiliate from '../../../assets/images/icons/affilite.svg'
import searchGray from '../../../assets/images/icons/searchGray.svg'
import coinsGold from '../../../assets/images/icons/CoinsGold.svg'
import usersquare from '../../../assets/images/icons/User_Square.svg'
import phoneGray from '../../../assets/images/icons/phonegray.svg'
import emailGray from '../../../assets/images/icons/Mail.svg'
import book from '../../../assets/images/icons/book.svg'
import { getFixedValueToNonDecimal, trunCateString } from "../../../utils/constant";

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler =
        (property) => (event) => {
            if (property === "action") {
                return;
            }
            onRequestSort(event, property);
        };

    const headCells = [
        {
            id: "id",
            numeric: false,
            disablePadding: true,
            label: "S. no",
            type: "",
        },
        {
            id: "username",
            numeric: false,
            disablePadding: true,
            label: "Username",
            type: "",
        },
        {
            id: "email",
            numeric: false,
            disablePadding: true,
            label: "Email",
            type: "",
        },
        {
            id: "phone",
            numeric: false,
            disablePadding: true,
            label: "Phone",
            type: "",
        },
        {
            id: "searches",
            numeric: false,
            disablePadding: true,
            label: "Searches",
            type: "",
        },

        {
            id: "creditused",
            numeric: false,
            disablePadding: true,
            label: "Credit used",
            type: "",
        }
    ];

    return (
        <TableHead className={`hideActionSort `}>
            <TableRow sx={{
                background: '#DBECFF !important', height: "50px", "& th": {
                    backgroundColor: "inherit !important"
                },
            }}>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                IconComponent={null}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


const ActiveSubscription = () => {
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const {
        sort_key,
        planDetails,
        recurringEndDate
    } = useSelector((state) => state.subscriptionSlice);
    const {isScreenZoomed} = useSelector(state => state.commonSlice)
    const handleRequestSort = (
        event,
        property
    ) => {
        const isAsc = orderBy === property && order === "asc";

        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        dispatch(
            updateSubscription({
                sort_type: isAsc ? "asc" : "desc",
                sort_key: property,
            }),
        );
        dispatch(getAllBrandForDropDown());
    };

    useEffect(() => {

        dispatch(getActivePlanDetails());
        // return () => dispatch(resetSubscription())
    }, []);

    const CampaignDetailsToolTip = (newData) => {


        let data = newData.data;
        return (
            <>
                <Stack direction="column" gap={0.5} sx={{ background: 'white', width: '100%', padding: '8px 16px' }}>
                    <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                        <Typography sx={{ color: '#726C6C', fontWeight: '500', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center' }}>
                            <img src={paidIcon} alt="myPlanIcon" height={18} width={18} />&nbsp;Paid&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />
                        </Typography>
                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(data?.usePaid)}/{getFixedValueToNonDecimal(data?.actualPaid) || "N/A"}</Typography>
                    </Stack>
                    <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                        <Typography sx={{ color: '#726C6C', fontWeight: '500', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center' }}>
                            <img src={barter} alt="myPlanIcon" height={18} width={18} />&nbsp;Barter&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />
                        </Typography>
                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(data?.useBarter)}/{getFixedValueToNonDecimal(data?.actualBarter) || "N/A"}</Typography>
                    </Stack>
                    <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                        <Typography sx={{ color: '#726C6C', fontWeight: '500', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center' }}>
                            <img src={performance} alt="myPlanIcon" height={18} width={18} />&nbsp;Performance&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />
                        </Typography>
                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(data?.useAffiliate)}/{getFixedValueToNonDecimal(data?.actualAffiliate) || "N/A"}</Typography>
                    </Stack>
                    <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                        <Typography sx={{ color: '#726C6C', fontWeight: '500', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center' }}>
                            <img src={affiliate} alt="myPlanIcon" height={18} width={18} />&nbsp;Affiliate&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />
                        </Typography>
                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(data?.usePerformance)}/{getFixedValueToNonDecimal(data?.actualPerformance) || "N/A"}</Typography>
                    </Stack>
                </Stack>
            </>)
    }
    return <>
        <Stack
            className="mainTitle flex-wrap mb-3"
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{
                minHeight: '42px',
                paddingX: '16px',
            }}>
            <Typography className="page-title" variant="h1">Active Plan</Typography>
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="upgradePlanButton-hover text-decoration-none upgradePlanButton "><img src={diamond} width={24} height={24} alt="" />&nbsp;Upgrade Plan</Link>
        </Stack>
        <div className="row p-0 m-0">
            {recurringEndDate &&
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="recurrInfo">
                        <div>
                            <h4>You have a recurring subscription set.</h4>
                            <p>Next billing date : <span>{getFormatedDate(planDetails?.recurringEndDate?.nextbillingDate, "DD MMMM YYYY")}</span></p>
                        </div>
                        <button className="btnDanger" onClick={() => setOpen(true)} >
                            Cancel
                        </button>
                    </div>
                </div>}
            <Grid container rowSpacing={{ xs: 3, sm: 2, md: 2, lg: 3, xl: 0 }} columnSpacing={{ xs: 0, sm: 1, md: 1, lg: 3, xl: 3 }} sx={{
                paddingX: '2rem',
            }} >

                <Grid item xl={3.5} lg={4} md={6} sm={6} xs={12}>
                    <Box sx={{ position: 'relative', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', padding: '2px', borderRadius: '10px', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', overflow: 'hidden' }}>
                        <Stack direction="column" gap={2} sx={{ height: '195px', width: '100%', background: 'white', borderRadius: '8px', padding: '10px 15px' }} >
                            <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                    <img src={myPlanIcon} alt="myPlanIcon" height={24} width={24} />&nbsp;My Plan&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                </Typography>
                                <Tooltip    arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "white !important",
                                  color: "black",textTransform:'capitalize',
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  padding: "5px 10px !important",
                                  borderRadius: "6px", minWidth: '100px',
                                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", border: '1px solid #F0F0F0 !important'
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "white !important",
                                  "&::before": {
                                    backgroundColor: "white", border: '1px solid #F0F0F0 !important',
                                  },
                                },
                              },
                            }} placement="top" title={planDetails?.basicInfo?.name}>
                                <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', backgroundClip: "text", color: 'transparent',textTransform:'capitalize' }}>{trunCateString(planDetails?.basicInfo?.name,isScreenZoomed ? 10 : 20) || "N/A"}</Typography>

                                </Tooltip>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                    <img src={recipt} alt="myPlanIcon" height={24} width={24} />&nbsp;Billing Period&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                </Typography>
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{"N/A"}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                    <img src={creditCard} alt="myPlanIcon" height={24} width={24} />&nbsp;Next Payment&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                </Typography>
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{"N/A"}</Typography>
                            </Stack>
                            <hr />
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', backgroundClip: "text", color: 'transparent' }}>Need More credits...</Typography>
                                <Typography sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '16px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px' }} className="upgradePlanButton-hover upgradePlanButton">
                                    <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={24} width={24} /> Upgrade</Link>
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </Grid>
                <Grid item xl={3.5} lg={4} md={6} sm={6} xs={12}>
                    <Box sx={{ position: 'relative', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', padding: '2px', borderRadius: '10px', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', overflow: 'hidden' }}>
                        <Stack direction="column" gap={2} sx={{ height: '195px', width: '100%', background: 'white', borderRadius: '8px', padding: '10px 15px' }} >
                            <Box>
                                <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                    <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                        <img src={coinsGold} alt="myPlanIcon" height={24} width={24} />&nbsp;Total Credit remains&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                    </Typography>
                                    <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#0A0A0B' }}> {getFixedValueToNonDecimal((Number(planDetails?.basicInfo?.actualSearchView) + Number(planDetails?.basicInfo?.actualProfileView)) - (Number(planDetails?.basicInfo?.useSearchView) + Number(planDetails?.basicInfo?.useProfileView)))}/{getFixedValueToNonDecimal(Number(planDetails?.basicInfo?.actualSearchView) + Number(planDetails?.basicInfo?.actualProfileView))}</Typography>
                                </Stack>
                                <Stack direction="column" gap={1} sx={{ paddingTop: '5px' , }} >
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                        <Typography sx={{fontWeight: '500',paddingRight:'33px', fontFamily: "var(--family1)", justifyContent: 'center', width: '50%', fontSize: '12px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
                                            <img src={searchGray} alt="myPlanIcon" height={18} width={18} />&nbsp;Search View&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />
                                        </Typography>
                                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualSearchView - planDetails?.basicInfo?.useSearchView) || "N/A"}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualSearchView)|| "N/A"}</Typography>
                                    </Stack>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)",paddingRight:'33px', justifyContent: 'center', width: '50%', fontSize: '12px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
                                            <img src={usersquare} alt="myPlanIcon" height={18} width={18} />&nbsp;Profile View&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />
                                        </Typography>
                                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualProfileView - planDetails?.basicInfo?.useProfileView)|| "N/A"}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualProfileView) || "N/A"}</Typography>
                                    </Stack>
                                </Stack>
                            </Box>
                            <Box>
                                <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                    <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                        <img src={book} alt="myPlanIcon" height={24} width={24} />&nbsp;Contact Credits&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                    </Typography>
                                    <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{getFixedValueToNonDecimal((Number(planDetails?.basicInfo?.actualPhoneNumber) + Number(planDetails?.basicInfo?.actualEmail))-(Number(planDetails?.basicInfo?.usePhoneNumber) + Number(planDetails?.basicInfo?.useEmail))) || "N/A"}/{getFixedValueToNonDecimal(Number(planDetails?.basicInfo?.actualPhoneNumber) + Number(planDetails?.basicInfo?.actualEmail)) || "N/A"}</Typography>
                                </Stack>
                                <Stack direction="column" gap={1} sx={{ paddingTop: '5px' }}>

                                    <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", paddingRight:'33px',justifyContent: 'center', width: '50%', fontSize: '12px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
                                            <img src={phoneGray} alt="myPlanIcon" height={18} width={18} />&nbsp;Phone no.&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />&nbsp;&nbsp;&nbsp;
                                        </Typography>
                                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualPhoneNumber - planDetails?.basicInfo?.usePhoneNumber) || "N/A"}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualPhoneNumber) || "N/A"}</Typography>
                                    </Stack>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                        <Typography sx={{  fontWeight: '500', paddingRight:'43px',fontFamily: "var(--family1)", justifyContent: 'center', width: '50%', fontSize: '12px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
                                            <img src={emailGray} alt="myPlanIcon" height={18} width={18} />&nbsp;Email ID&nbsp;<img src={questionGrey} alt="questionCircle" width={16} height={16} />&nbsp;&nbsp;
                                        </Typography>
                                        <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', color: '#726C6C' }}>{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualEmail - planDetails?.basicInfo?.useEmail) || "N/A"}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualEmail) || "N/A"}</Typography>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>

                <Grid item xl={3.5} lg={4} md={6} sm={6} xs={12}>
                    <Box sx={{ position: 'relative', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', padding: '2px', borderRadius: '10px', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', overflow: 'hidden' }}>
                        <Stack direction="column" gap={2} sx={{ height: '195px', width: '100%', background: 'white', borderRadius: '8px', padding: '10px 15px' }} >
                            <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                    <img src={user} alt="myPlanIcon" height={24} width={24} />&nbsp;Unique User Login&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                </Typography>
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{getFixedValueToNonDecimal(planDetails?.activeUsers)}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualUniqueUsersLogin) || "N/A"}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                    <img src={userCheck} alt="myPlanIcon" height={24} width={24} />&nbsp;Approved Influencers&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                </Typography>
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{getFixedValueToNonDecimal(planDetails?.basicInfo?.useInfluencerApproved)}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualInfluencerApproved) || "N/A"}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center', }}>
                                    <Tooltip placement="bottom-start" arrow componentsProps={{
                                        tooltip: {
                                            sx: {
                                                border: "2px solid var(--color-blue) !important",
                                                marginTop: '3px !important',
                                                backgroundColor: "white !important",
                                                color: "black !important",
                                                borderRadius: '5px',
                                                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                                width: "264px", height: '118px', padding: '0.5px !important'
                                            },
                                        },
                                        arrow: {
                                            sx: {

                                                color: "var(--color-blue) !important",
                                                "&::before": {
                                                    backgroundColor: "var(--color-blue)",
                                                },
                                            },
                                        },
                                    }}
                                        title={<CampaignDetailsToolTip data={planDetails?.basicInfo} />
                                        }>

                                        <img src={rocket} alt="myPlanIcon" height={24} width={24} />&nbsp;Total Campaign&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{getFixedValueToNonDecimal(getFormatedNumber(planDetails?.basicInfo?.actualPaid) + getFormatedNumber(planDetails?.basicInfo?.actualBarter) + getFormatedNumber(planDetails?.basicInfo?.actualAffiliate) + getFormatedNumber(planDetails?.basicInfo?.actualPerformance)) || "N/A"}</Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>
        </div>
        <div className="p-3 mt-2">
            <Typography variant="h4">
                Unique User Logins : <span style={{ color: 'var(--color-blue)' }}>{getFixedValueToNonDecimal(planDetails?.activeUsers)}/{getFixedValueToNonDecimal(planDetails?.basicInfo?.actualUniqueUsersLogin)}</span>
            </Typography>
        </div>
        <TableContainer sx={{ maxHeight: 350 }}>
            <Table
                stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                    order={order}
                    orderBy={sort_key}
                    onRequestSort={handleRequestSort}
                    numSelected={0}
                    onSelectAllClick={function (

                    ) {
                        throw new Error("Function not implemented.");
                    }}
                />
                <TableBody>
                    {planDetails?.userInfo?.length > 0 ? (
                        planDetails?.userInfo?.map((row, index) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row?.id}
                                    className={"tableRow"}
                                    sx={{
                                        "&:hover": {
                                            backgroundColor: '#F0F7FF !important', "& td": {
                                                backgroundColor: "inherit !important"
                                            },
                                        }, height: '60px'
                                    }}>
                                    <TableCell component="td" scope="row" >
                                        {++index}
                                    </TableCell>
                                    <TableCell component="td" scope="row">
                                        <Stack direction={"row"} >
                                            <Avatar
                                                alt={row?.contactPersonName}
                                                src={row.logo}
                                                sx={{ height: '35px', width: '35px', borderRadius: "50%" }}
                                            />
                                            <span className="text-decoration-none text-capitalize" style={{ fontSize: '13px', fontWeight: '500', letterSpacing: '0px', marginLeft: '10px', marginTop: "4px" }}>{row?.contactPersonName || "N/A"}</span>
                                        </Stack>
                                    </TableCell>
                                    <TableCell component="td" scope="row">
                                        {row?.email}
                                    </TableCell>

                                    <TableCell align="left">
                                        {row?.phoneNumber || "N/A"}
                                    </TableCell>
                                    <TableCell align="left">
                                        {getFixedValueToNonDecimal(row?.searchView) || 0}
                                    </TableCell>
                                    <TableCell align="left">
                                        {getFixedValueToNonDecimal(getFormatedNumber(row?.emailView) + getFormatedNumber(row?.searchView) + getFormatedNumber(row?.profileView) + getFormatedNumber(row?.usephoneNumber) + getFormatedNumber(row?.uniqueUsersLogin) + getFormatedNumber(row?.influencerApproved) + getFormatedNumber(row?.paid) + getFormatedNumber(row?.barter) + getFormatedNumber(row?.affiliate) + getFormatedNumber(row?.performance))}
                                    </TableCell>

                                </TableRow>
                            );
                        })
                    ) : (
                        <TableRow colSpan={10}>
                            <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                                <Typography
                                    color="inherit"
                                    variant="subtitle1"
                                    alignItems={"center"}
                                    component="h3"
                                >
                                    No Data found!
                                </Typography>

                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
        <CommonModel
            open={open}
            handleDialogClose={() => setOpen(false)}
            dialogTitle={"Cancel recurring subscription"}
            dialogPara={`Are you sure, you want to cancel the recurring subscription?`}
            nvCancel={"Cancel"}
            nvYes={"Yes"}
            yesHandle={() => {
                dispatch(cancelRecurringSubscription());
                setOpen(false)
            }}
        />
    </>
}

export default ActiveSubscription